import { ThunkDispatch } from 'redux-thunk';
import {
  addGalleryMedia,
  getGalleryAllList,
  removeGalleryMedia,
} from '../../../features/gallerySlice';
import { toast } from 'react-toastify';
import { CLICK_ACTIONS } from '../../../utils/Constant';

/**
 * Makes an API call to remove an image from the list by passing image ID.
 */
export const handleRemove = (
  dispatch: ThunkDispatch<any, any, any>,
  deleteId: string | number,
  options: {
    setShowLoader: (showLoader: boolean) => void;
    setShowAlertPopUp: (showAlertPopUp: boolean) => void;
    setDeleteId: (deletedId: string | number) => void;
  }
) => {
  const { setShowLoader, setDeleteId, setShowAlertPopUp } = options;
  setShowLoader(true);
  dispatch(removeGalleryMedia({ id: deleteId }))
    .then((fulfilled: any) => {
      toast.success(fulfilled.payload.responseInformation.responseMessage);
      setShowAlertPopUp(false);
      setDeleteId('');
      setShowLoader(false);
      dispatch(getGalleryAllList());
    })
    .catch(() => {
      setShowLoader(false);
    });
};

/**
 * Validates the count of files. If the count is 0 or exceeds 18,
 * an error is shown, and an API call is made.
 */
export const uploadSelectedFiles = (
  files: File[],
  galleryList: any[],
  dispatch: ThunkDispatch<any, any, any>,
  options: {
    setShowLoader: (showLoader: boolean) => void;
    setNewFiles: (files: any[]) => void;
  }
) => {
  const { setShowLoader, setNewFiles } = options;
  if (!files || files.length === 0) {
    return;
  }
  if (files?.length + galleryList?.length > 18) {
    toast.error(
      'Only 18 files are allowed in total. Please reduce the number of files before uploading'
    );
    return;
  }
  const formData = new FormData();
  const allSelectedFiles = Object.values(files).flat();
  allSelectedFiles.forEach((file: File) => {
    formData.append('mediaFiles', file);
  });
  setShowLoader(true);
  dispatch(addGalleryMedia(formData))
    .then((fulfilled: any) => {
      toast.success(fulfilled.payload.responseInformation.responseMessage);
      setShowLoader(false);
      setNewFiles([]);
      dispatch(getGalleryAllList());
    })
    .catch(() => {
      setShowLoader(false);
    });
};

/**
 * Displays an alert popup when the remove icon is clicked.
 */
export const onRemoveClick = (
  id: number | string,
  setShowAlertPopUp: (showAlertPopUp: boolean) => void,
  setDeleteId: (deletedId: number | string) => void
) => {
  setShowAlertPopUp(true);
  setDeleteId(id);
};

/**
 * Handles the functionality for the Yes and No buttons.
 *
 * If click on Yes calling remove API
 * if No, closing the Alert modal
 */

export const alertPopupToggle = (
  action: string,
  dispatch: ThunkDispatch<any, any, any>,
  options: {
    setShowLoader: (showLoader: boolean) => void;
    setShowAlertPopUp: (showAlertPopUp: boolean) => void;
    setDeleteId: (deletedId: string | number) => void;
    deleteId: string | number;
  }
) => {
  const { deleteId, setShowLoader, setShowAlertPopUp, setDeleteId } = options;
  if (action === CLICK_ACTIONS.APPROVE) {
    handleRemove(dispatch, deleteId, {
      setShowLoader,
      setShowAlertPopUp,
      setDeleteId,
    });
  } else {
    setShowAlertPopUp(false);
    setDeleteId('');
  }
};
